export const drugMobileTocTabTypes = {
  QUICK_ANSWERS: "content-quick-answers-tab",
  IN_DEPTH_ANSWERS: "content-indepth-answers-tab",
};
